import { useEffect, useState, useCallback } from "react";
import api from "../services/apiServices";
import { useAdminStore } from "../store/adminStore"; // <-- NEW IMPORT


export default function useCategoryDraftQuestions(categoryId) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const locale = useAdminStore((state) => state.locale); // <-- GET CONTEXT

  const fetchQuestions = useCallback(async () => {
    if (!categoryId) return;
    setLoading(true);
    try {
      const res = await api.get(`/admin/categories/cat-qna/category/${categoryId}`, {
        params: { status: "draft", locale: locale},
      });
      console.log("✅ fetched questions:", res.data);
      setQuestions(
        (res.data || []).sort((a, b) => a.order_index - b.order_index)
      );
      setError(null);
    } catch (err) {
      setError(err);
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  }, [categoryId]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  return { questions, loading, error, refetch: fetchQuestions };
}
